import React from 'react';
import { Building2, Shield } from 'lucide-react';

export function NoAssignedHotels() {
	return (
		<div className="min-h-screen flex items-center justify-center p-8">
			<div className="max-w-xl w-full text-center bg-white/40 backdrop-blur-xl rounded-3xl border border-gray-200 p-10">
				<div className="w-20 h-20 bg-gray-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
					<Building2 className="w-10 h-10 text-gray-400" />
				</div>
				<h1 className="text-3xl font-display font-bold text-gray-900 mb-3">No Hotels Assigned</h1>
				<p className="text-gray-600 font-text leading-relaxed mb-8">
					You don t have access to any hotels yet. Please contact your administrator to be assigned to one or more hotels.
				</p>
				<div className="flex items-center justify-center space-x-3 text-gray-500 text-sm">
					<Shield className="w-4 h-4" />
					<span>Access is managed by your organization s admin</span>
				</div>
			</div>
		</div>
	);
}
